import { openEmailViewer } from "../../util/openEmailViewer.ts";

export interface ResendArgs {
  emailLogId: number;
  transactionId: number;
  customerEmail?: string;
}

interface ButtonInfo {
  rowData: string[];
  pageName: string;
  type: number;
  label: string;
}

type Toast = (msg: string, kind: "success" | "error" | "warning") => void;

/** Dispatch a customerEmailLog row-button click. Mirrors WebAdmin2
 *  columnvalue.ts: type 112 = View Email; type 20/21 with pageName "239"
 *  = Resend email. Anything else surfaces a warning toast — the alternative
 *  is silently re-routing every button to the email viewer, which is the
 *  bug we just fixed. */
export function handleEmailLogButton(
  info: ButtonInfo,
  row: unknown[],
  colIndex: Record<string, number>,
  toast: Toast,
  openResend: (args: ResendArgs) => void,
): void {
  const cell = (name: string): string | undefined => {
    const ix = colIndex[name];
    if (ix == null) return undefined;
    const v = row[ix];
    return v == null ? undefined : String(v);
  };

  if (info.type === 112) {
    const [transactionId, logId] = info.rowData;
    void openEmailViewer(transactionId ?? "", logId ?? "").then((err) => {
      if (err) toast(err, "error");
    });
    return;
  }

  if ((info.type === 20 || info.type === 21) && info.pageName === "239") {
    const tid = Number(cell("iTransactionID") ?? cell("itransactionid"));
    const lid = Number(cell("iEmailLogID") ?? cell("iemaillogid"));
    if (!Number.isFinite(tid) || !Number.isFinite(lid)) {
      toast("Could not resolve transaction/email IDs from the row.", "error");
      return;
    }
    openResend({ emailLogId: lid, transactionId: tid, customerEmail: cell("sEmail") ?? cell("semail") });
    return;
  }

  toast(`Unhandled email-log button (type ${info.type}, pageName "${info.pageName}").`, "warning");
}
